import { Card, CardContent, Skeleton } from "frontend-components";
import { useTranslation } from "react-i18next";
import { useIssuesCategoryMetrics } from "./useIssuesCategoryMetrics";

function StatCard({ value, label }: { value: React.ReactNode; label: string }) {
    return (
        <Card
            size="sm"
            className="bg-compendia-greige-10 border border-compendia-border gap-0 py-3 items-center justify-center text-center"
        >
            <CardContent className="flex flex-col items-center justify-center px-4">
                <div className="text-3xl font-bold text-compendia-foreground mb-1">{value}</div>
                <p className="text-[10px] font-semibold uppercase tracking-category text-compendia-gray-60">
                    {label}
                </p>
            </CardContent>
        </Card>
    );
}

export default function IssuesCategoryStats() {
    const { t } = useTranslation();
    const {
        totalDeviations,
        totalCategories,
        highestCategoryName,
        highestCategoryPercentage,
        isLoading,
    } = useIssuesCategoryMetrics();

    if (isLoading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {[1, 2, 3].map((i) => (
                    <Card
                        key={i}
                        size="sm"
                        className="bg-compendia-greige-10 border border-compendia-border gap-0 py-3 items-center justify-center text-center"
                    >
                        <CardContent className="flex flex-col items-center justify-center px-4">
                            <Skeleton className="bg-compendia-greige-60 w-16 h-8 rounded-full mb-1" />
                            <Skeleton className="bg-compendia-greige-60 w-20 h-3 rounded-full" />
                        </CardContent>
                    </Card>
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <StatCard
                value={totalDeviations}
                label={t("common.totalAmountOfDeviations").toUpperCase()}
            />
            <StatCard value={totalCategories} label={t("common.categories").toUpperCase()} />
            <StatCard
                value={`${Math.round(highestCategoryPercentage)}%`}
                label={highestCategoryName.toUpperCase()}
            />
        </div>
    );
}
